import { useMemo } from "react"

import { useParams } from "react-router-dom"

import { GradeBadge } from "@l2r-front/l2r-common"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { ColoredBadge } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { notationLegend } from "../../constants/getNotationConfig"
import { networkGradingsQueryKeys } from "../../hooks/queries/networkGradings/queryKeys"
import { useNetworkGrading } from "../../hooks/queries/networkGradings/useNetworkGrading"
import { useWeightedAverageGrades } from "../../hooks/queries/networkGradings/useWeightedAverageGrades"

import * as Styled from "./RoadNotationGrade.styled"

export function RoadNotationGrade(props) {

    const {
        networkGrading,
        notationKey,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const { road } = useParams()

    const { selectedSubNetworkSlugs } = useNetworksStateContext()
    const queryKeyParams = {
        ...(selectedSubNetworkSlugs?.length > 0 && { sub_networks: selectedSubNetworkSlugs.join(",") }),
    }

    const { data: roadSegments, isLoading, isError } = useNetworkGrading(
        networkGrading,
        {
            ...queryKeyParams,
            linear_location_road: road,
        },
        {
            enabled: !!road,
        },
        networkGradingsQueryKeys.list(queryKeyParams),
    )
    const averageGrades = useWeightedAverageGrades(roadSegments?.features)

    const grade = useMemo(() => {
        if (!averageGrades) {
            return null
        }
        return averageGrades[notationKey]
    }, [notationKey, averageGrades])

    if (isLoading || (!roadSegments && !isError)) {
        return <Styled.Skeleton />
    }

    if (isError) {
        return <ColoredBadge
            backgroundColor="error"
            text={t(I18N_NAMESPACE, "containers.weightedAverageNotationGrade.error")}
            textVariant="Desktop & Mobile/Heading/H3"
        />
    }

    return <GradeBadge grade={grade} legend={notationLegend} />
}